import Pristine from 'pristinejs';
import updateDonationHeaderCTA from '../modules/donation-links';
import { getInstance } from '../modules/ga4-tracking';

document.addEventListener('alpine:init', () => {
  Alpine.data('donationsVIC', (
    input,
    isPuppyPals,
    donationType,
    iframeBaseUrl,
    campaign,
    hasMidStep,
    formNameGA,
    prefill,
    hideHandles,
    isCampaignForm,
  ) => {
    let form = null;
    let $form = null;

    let pristine = null;
    let tracking = getInstance();

    return {
      ...input,
      activeIndex: 0,
      errors: {},
      formName: formNameGA,
      donorFirstName: '',
      donorLastName: '',
      donorEmail: '',
      ballColour: '',
      donationType: donationType,
      donationBy: 'individual',
      companyName: '',

      ValidateStep2: {},
      ValidateStep3: {},
      donationAmount: hideHandles ? 'other' : null,
      donationAmountOther: null,
      _errorMsg: '',
      _loading: false,
      $iframe: null,

      init() {
        form = document.getElementById('donationsVIC');
        $form = $(form);

        this.$iframe = $form.find('[data-js-donate-iframe]');

        pristine = new Pristine(form);

        pristine.addValidator(
          document.querySelector('[name="other-amount"]'),
          (val) => {
            const frequency =
              $('[name="donate-frequency"]:checked').val() ||
              $('[name="donate-frequency"][type="hidden"]').val();

            switch (frequency) {
              case 'Monthly':
                return val >= 10;
              case 'One-off':
                return val > 0;
              default:
                return val >= 20; // if no frequency input ':checked' it must be a puppy pals donation
            }
          },
          () => {
            const frequency = $('[name="donate-frequency"]:checked').val();

            switch (frequency) {
              case 'Monthly':
                return 'The minimum amount for monthly donations is $10.';
              case 'One-off':
                return 'The minimum amount for one-off donations is $0.01.';
              default:
                return 'The minimum amount for Puppy Pal donations is $20.';
            }
          },
        );

        const alpineThis = this;

        updateDonationHeaderCTA($form, null, 'donate', false);

        this.setPreSelectedDonationAmount(alpineThis);

        this.handlePrefill(prefill);

        $('[name="donate-frequency"]').on('change', function () {
          let otherId = '';

          $('[name="donate-value"]').each(function () {
            if ($(this).prop('value') === 'other' && $(this).prop('checked')) {
              const id = $(this).prop('id');
              if (id === 'monthly-other') {
                otherId = 'one-off-other';
              } else if (id === 'one-off-other') {
                otherId = 'monthly-other';
              }
            }
            $(this).prop('checked', false);
          });

          if (otherId) {
            $('#' + otherId).prop('checked', true);
          }

          alpineThis.setPreSelectedDonationAmount(alpineThis);
        });

        if ($('[name="donate-value"]:checked').val()) {
          alpineThis.donationAmount = $('[name="donate-value"]:checked').val();
        }

        $('[name="donate-value"]').on('change', function () {
          const other = $('[name="other-amount"]');

          alpineThis.donationAmount = $(this).val();

          alpineThis.donationAmountOther = null;

          other.val('');
        });

        $('[name="other-amount"]').on('input', function () {
          const donateValue = $('[name="donate-value"]').not('[value="other"]');

          donateValue.each(function () {
            $(this).prop('checked', false);
          });
        });

        const donationIframe = document.querySelector('.donation__iframe');
        const donationIframeLoad = document.querySelector('.iframe-load');
        const ddsaMessage = document.querySelector('.ddsa-message');

        if (donationIframe && donationIframeLoad) {
          // Set-up el styles
          donationIframe.style.opacity = 0;

          donationIframe.addEventListener('load', () => {
            // iframe is being unloaded
            if (!this._isUrl(donationIframe.src)) {
              donationIframeLoad.classList.remove('u-none');
              ddsaMessage.classList.remove('u-block');
              donationIframe.classList.remove('entered');
              return;
            }

            // iframe has loaded
            setTimeout(() => {
              donationIframeLoad.classList.add('u-none');
              ddsaMessage?.classList.add('u-block');
              ddsaMessage?.classList.add('fadeIn', 'mobileFadeIn');
              ddsaMessage?.classList.add('entered');
              donationIframe.classList.add('fadeIn', 'mobileFadeIn');
              donationIframe.classList.add('entered');
            }, 700);
          });
        }

        this.$watch('activeIndex', () => this.$store.stepperIndex.index = this.activeIndex);
      },
      loading(isLoading = true) {
        //TODO add a spinner in the html that read this as well
        this._loading = isLoading;
      },
      error(errorMessage, errorObject = null) {
        this._errorMsg = errorMessage;
        console.error(errorObject); //TODO let's remove this and do it properly
      },
      _next(dispatch) {
        this.activeIndex = Math.min(this.activeIndex + 1, input.steps.length - 1);

        if (dispatch && this.activeIndex === 1) {
          dispatch('appealformfocus');
        } else {
          this.scrollTop();
        }
      },
      next(dispatch) {
        if (this.validateForm() === false) {
          this.scrollTop();
          return;
        }

        this.setTrackingCookie();

        let newIndex = Math.min(this.activeIndex + 1, input.steps.length - 1);

        if (!hasMidStep || (hasMidStep && newIndex === 2)) {
          if (this.donorFirstName) {
            document.cookie = `campaign-supportername=${this.donorFirstName};path=/`;
          }

          if (this.donorEmail) {
            document.cookie = `campaign-supporteremail=${this.donorEmail};path=/`;
          }

          if (this.ballColour) {
            document.cookie = `campaign-ballcolour=${this.ballColour};path=/`;
          }

          this.loadIframe();
        }

        this._next(dispatch);
      },
      loadIframe() {
        const typeOfDonation = isPuppyPals
          ? 'puppy-pal'
          : this.donationType.toLowerCase();

        const params = {
          PaymentByName: this.donationBy === 'Company' ? this.companyName : '',
          payMType: campaign,
          donationamount: this._get_donation_amount(),
          payfrequency: this.donationType,
          customField2Name: 'type_of_donation__c',
          customField2Value:
            typeOfDonation === 'one-off' && this.formName === 'current-appeal'
              ? this.formName
              : (isCampaignForm ? 'current-appeal' : typeOfDonation),
          customField3Name:
            typeOfDonation === 'one-off' ? 'Donation_Source__c' : '',
          customField3Value: typeOfDonation === 'one-off' ? 'Online' : '',
          HidePayFrequency: isPuppyPals,
        };

        if (this.formName === 'ball-pit') {
          params.customField2Value = 'ball-pit';
          params.firstname = this.donorFirstName;
          params.lastname = this.donorLastName;
          params.email = this.donorEmail;
        }

        const src = new URL($form.attr('data-js-donate-url') || iframeBaseUrl);

        for (const [key, value] of Object.entries(params)) {
          if (value) {
            src.searchParams.append(key, value);
          }
        }

        this.$iframe.attr('src', '');
        this.$iframe.attr('src', src);
      },
      setTrackingCookie() {
        this.setCookie(
          this.formName,
          this._get_donation_amount(),
          this.donationType,
        );
      },
      setCookie(formName, amount, frequency) {
        const timestamp = Date.now();
        document.cookie = `campaign-timestamp=${timestamp};path=/`;
        // Only set cookie if all values are present
        if (formName) {
          document.cookie = `campaign=${formName};path=/`;
        }
        if (formName === 'donottrack') {
          //Don't set extra cookie data on a donottrack request
          return;
        }
        if (amount && frequency) {
          document.cookie = `campaign-amount=${amount};path=/`;
          document.cookie = `campaign-frequency=${frequency};path=/`;
          document.cookie = `campaign-source=${window.location.href};path=/`;
        }
      },
      prev() {
        this.activeIndex = Math.max(this.activeIndex - 1, 0);

        this.$iframe.attr('src', '');

        this.scrollTop();
      },
      scrollTop() {
        $('html, body').animate(
          {
            scrollTop:
              $('#formStepper').offset().top - $('#header').outerHeight(),
          },
          150,
        );
      },
      submit() {
        //this.validateForm();
      },
      validateForm() {
        const errors = {};

        // Reset errors initially.
        this.errors = errors;

        // Grab all visible elements on the current step.
        const $currentStepElements = $(
          'input:not(:hidden), select:not(:hidden), texarea:not(:hidden)',
          '.donate-form__step.is-active',
        );

        let valid = pristine.validate($currentStepElements);

        // Go through each of the elements and find out if they have errors.
        $currentStepElements.each((i, el) => {
          const individualErrors = pristine.getErrors(el);

          $(el).removeAttr('aria-invalid');

          if (individualErrors && individualErrors.length) {
            errors[el.getAttribute('name')] = individualErrors[0];

            $(el).attr('aria-invalid', 'true');
          }
        });

        // Set new errors.
        this.errors = errors;

        return valid;
      },
      _get_donation_amount() {
        let amount = this.donationAmount;

        if (
          !isNaN(this.donationAmountOther) &&
          parseInt(this.donationAmountOther, 10) > 0
        ) {
          amount = this.donationAmountOther;
        }

        amount = parseFloat(amount);

        if (isNaN(amount) || amount < 1) {
          amount = 1;
        }

        return amount;
      },
      _isUrl(string) {
        try {
          new URL(string);
          return true;
        } catch (err) {
          return false;
        }
      },
      handlePrefill(prefillData) {
        Object.keys(prefillData).forEach((val) => {
          switch (val) {
            case 'donationType':
            case 'donationAmountOther':
              this[val] = prefillData[val];
              break;
            case 'donationAmount':
              this['donationAmount'] = prefillData[val];
              const donationtype =
                prefillData['donationType'] || this.donationType;
              const preSelectedHandle = $(
                `[data-js-conditional-value=${donationtype}] [value=${this['donationAmount']}]`,
              );
              preSelectedHandle.prop('checked', true);
              break;
            default:
              break;
          }
        });

        if (prefillData.step === '2') {
          this.next();
        }
      },
      setPreSelectedDonationAmount() {
        const preSelectedHandle = $(
          `[data-js-conditional-value=${this.donationType}] [data-preselected]`,
        );
        const otherHandle = $(
          `[data-js-conditional-value=${this.donationType}] [value='other']`,
        );

        if (preSelectedHandle.length) {
          preSelectedHandle.prop('checked', true); // Required for case where One-off and Monthly values are preselected
          this.donationAmount = preSelectedHandle.val();
          this.donationAmountOther = null;
        } else if (this.donationAmountOther) {
          otherHandle.length > 0 && otherHandle.prop('checked', true);
          this.donationAmount = 'other';
        }
      },
    }
  });
});
